import React, { useCallback, useEffect, useState, MouseEvent } from 'react';
import {
  EuiButton,
  EuiFlexGroup,
  EuiFlexItem,
  EuiLoadingSpinner,
  EuiSpacer,
  EuiTextArea,
  EuiTitle,
} from '@elastic/eui';
import TopBar from '../../ui/TopBar';
import { GoogleMapFull } from '../../ui/GoogleMapFull';
import { Dossier, INCO2Address } from '../../../types';
import ShowErrors from '../../ui/ShowErrors';
import Footerbar from '../../ui/Footerbar';
import { isConstructorDeclaration } from 'typescript';
import { Address } from 'node:cluster';

export const ViewHome: React.FC = () => {
  const [cheched, setChecked] = useState(false);
  const [step, setStep] = useState(0);
  const [pax, setPax] = useState(1);
  const [_lat, setLat] = useState(1);
  const [_lng, setLng] = useState(1);
  const [localized, setLocalized] = useState(false);
  const [note, setNote] = useState('');
  const [showNotes, setShowNotes] = React.useState(false);
  const [myid, setMyid] = useState('');
  const [error, setError] = useState(null);
  const [fattibile, setFattibile] = useState(false);
  const [isLoaded, setIsLoaded] = useState(false);
  const [blockproccess, setBlockproccess] = useState(false);
  const [errormesage, setErrorMessage] = useState('');
  const [avanti, setAvanti] = useState(false);
  const [manual, setManuale] = useState(false);
  const [locatorexit, setLocatorExit] = useState(false);
  const [usagps, setUsageGps] = useState(false);
  const [richiamatemi, setRichiamatemi] = useState(false);
  const [partenza, setPartenza] = useState('PARTENZA');
  const [arrivo, setArrivo] = useState('ARRIVO');
  const [mydirection, setDirection] = useState(-1);
  const [directionclicked, setDirectionClicked] = useState(false);
  const [back, setBack] = useState(false);
  const [directionFlag, setDirectionFlag] = useState('');
  const [enabled, setEnabled] = useState(false);
  const [company, setCompany] = useState(0);
  const [forzanogeo, seForzanogeo] = useState(false);
  const [directExit, setDirectExite] = useState(false);
  const [attivaBtnNSQ, setAttivaBtnNSQ] = useState(true);
  const [attivaBtnDRCT, setAttivaBtnDRCT] = useState(true);
  const [isloading, setIsloading] = useState(true);

  const [req1, setReq1] = useState({
    PaxNumber: pax,
    Address: {
      Street: '',
      PostalCode: '',
      City: '',
      ProvinceCode: '',
      ProvinceDescr: '',
      CountryCode: '',
      FormattedAddress: '',
      Latitude: 42,
      Longitude: 12,
    },
    Point: {
      PoiId: 0,
      PoiName: '',
      Km: 0,
      TreatCode: '',
      TreatId: 0,
      HighwayId: 0,
      HighwayName: '',
      HighwayCode: '',
      TreatName: '',
      Direction: mydirection,
    },
    ExitNote: null,
  });
  const [req2, setReq2] = useState({
    PaxNumber: pax,
    Address: {
      Street: '',
      PostalCode: '',
      City: '',
      ProvinceCode: '',
      ProvinceDescr: '',
      CountryCode: '',
      FormattedAddress: '',
      Latitude: 42,
      Longitude: 12,
    },
    ExitNote: note,
  });

  const IAddress: INCO2Address = {
    latitude: 42,
    longitude: 12,
    street: '',
    postalCode: '',
    city: '',
    provinceCode: '',
    provinceDescr: '',
    countryCode: '',
    formattedAddress: '',
  };

  const [address, setAddress] = useState<INCO2Address>();

  // @ts-ignore
  const checkurl = window.Configs.CHECK_URL;
  // @ts-ignore
  const getpoiurl = window.Configs.GETPOI_URL;
  // @ts-ignore
  const postcompleteurl = window.Configs.POST_COMPLETE_URL;
  //const IAddressDispacther: React.Dispatch<INCO2Address> = () => {};

  const listaconvenzionate = [
    {
      convezionata: 'IPAS',
      value: 12040241,
      externallink: true,
      privacytext:
        'https://assets.europassistance.it/Normativa/EAV%20-%20Informative%20Privacy/Informativa%20EA%20VAI%20-%20utente%20803%20803%20o%20n.%20telefono%20cds.pdf',
    },
    {
      convezionata: 'MAPFRE',
      value: 12040243,
      externallink: true,
      privacytext:
        ' https://www.mapfreassistance.it/informativa-privacy-e-cookies-policy-italy/',
    },
    {
      convezionata: 'ALLIANZ',
      value: 12040247,
      externallink: false,
      privacytext: 'Privacy Allianz Msite.pdf',
    },
    {
      convezionata: 'PA',
      value: 12040250,
      externallink: true,
      privacytext:
        'https://assets.europassistance.it/Normativa/EAV%20-%20Informative%20Privacy/Informativa%20EA%20VAI%20-%20utente%20803%20803%20o%20n.%20telefono%20cds.pdf',
    },
    {
      convezionata: 'EURA',
      value: 12040252,
      externallink: true,
      privacytext:
        'https://assets.europassistance.it/Normativa/EAV%20-%20Informative%20Privacy/Informativa%20EA%20VAI%20-%20utente%20803%20803%20o%20n.%20telefono%20cds.pdf',
    },
  ];

  //Oggi test
  //Check if logo exist or use EA logo
  const GetLogo = (CompanyId: number) => {
    if (CompanyId === null) {
      return '../loghi/12040252.png';
    }

    let myconvenzionata = listaconvenzionate.find(
      (cnv) => cnv.value === CompanyId
    );
    let res = '';
    if (myconvenzionata !== undefined) {
      res = '../loghi/' + myconvenzionata?.value + '.png';
    } else {
      res = '../loghi/12040252.png';
    }
    return res;
  };

  const printhyperlink = (CompanyId: number) => {
    let myconvenzionata = listaconvenzionate.find(
      (cnv) => cnv.value === CompanyId
    );
    let res = '';
    if (myconvenzionata !== undefined) {
      if (myconvenzionata.externallink) {
        res = myconvenzionata.privacytext;
      } else {
        res = '../loghi/' + myconvenzionata.privacytext;
      }
    } else {
      res =
        'https://assets.europassistance.it/Normativa/EAV%20-%20Informative%20Privacy/Informativa%20EA%20VAI%20-%20utente%20803%20803%20o%20n.%20telefono%20cds.pdf';
    }
    return res;
  };

  //#region  "STEP 0: Get my id from url"
  const getMyId = () => {
    let urlElements = window.location.href.split('/');
    let lastItem = urlElements.length - 1;
    if (urlElements[lastItem] !== '') {
      setMyid(urlElements[lastItem]);
      setFattibile(true);
    } else {
      setFattibile(false);
      setBlockproccess(true);
      setAvanti(false);
      setErrorMessage(
        'la tua richiesta non è valida, non hai un id attendibile'
      );
      //console.log('non hai un id attendibile');
      setStep(0);
    }
  };
  useEffect(() => {
    getLocation();
  }, [fattibile]);

  //#endregion

  //#region Get Geolocation cordinates Va allo step 2 se passa
  const getLocation = () => {
    if ('geolocation' in navigator) {
      navigator.geolocation.getCurrentPosition(
        function (position) {
          setLat(position.coords.latitude);
          setLng(position.coords.longitude);
          IAddress.latitude = position.coords.latitude;
          IAddress.longitude = position.coords.longitude;
          setLocalized(true); //

          //SETTING DELL'ADDRESSS
          let myaddresshere: INCO2Address = {
            //@ts-ignore
            Street: address?.street,
            //@ts-ignore
            PostalCode: address?.postalCode,
            City: address?.city,
            //@ts-ignore
            ProvinceCode: address?.provinceCode,
            //@ts-ignore
            ProvinceDescr: address?.provinceDescr,
            //@ts-ignore
            CountryCode: address?.countryCode,
            //@ts-ignore
            FormattedAddress: address?.formattedAddress,
            //@ts-ignore
            Latitude: position.coords.latitude,
            //@ts-ignore
            Longitude: position.coords.longitude,
          };
          setAddress(myaddresshere);
        },
        function (error) {
          if (error.code === error.PERMISSION_DENIED) {
            //@ts-ignore
            let msserr = window.Configs.ERROR_MESSAGE_GPS_VARIANT2;
            setErrorMessage(msserr);
            setUsageGps(true);
            setLocalized(false);
            setStep(0);
          }
        }
      );
    } else {
      //@ts-ignore
      let msserr = window.Configs.ERROR_MESSAGE_GPS_NOT;
      setBlockproccess(true);
      setErrorMessage(msserr);
      setLocalized(false);
    }
  };

  //#endregion

  const checkurlasync = async () => {
    await fetch(checkurl + myid)
      .then((res) => res.json())
      .then(
        (result) => {
          if (result.RequestStatus === 'OK') {
            ///IDCOMPANY
            if (result.CompanyId !== undefined) {
              setCompany(result.CompanyId);
            } else {
              setCompany(12040252);
            }

            //Numero dei pax
            if (result.PaxNumber !== undefined) {
              setPax(result.PaxNumber);
            } else {
              setPax(1);
            }
            setChecked(true);
            //Acconsento di andare avanti
            setAvanti(true);
            //Geolocalizzo
            getLocation();
            //setStep(2);
          } else {
            setStep(1);
            let rs = result.Error.ErrorCode;
            switch (rs) {
              case 400:
                if (result.Error.ErrorMessage !== null) {
                  setErrorMessage(result.Error.ErrorMessage);
                  if (result.Error.CompanyId !== undefined) {
                    setCompany(result.Error.CompanyId);
                  } else {
                    setCompany(12040252);
                  }
                } else {
                  //@ts-ignore
                  setErrorMessage(window.Configs.ERROR_400_EMPTY);
                  if (result.Error.CompanyId !== undefined) {
                    setCompany(result.Error.CompanyId);
                  } else {
                    setCompany(12040252);
                  }
                }
                setError(error);
                break;
              case 401:
                //@ts-ignore
                setErrorMessage(window.Configs.ERROR_401_CUSTOM);
                if (result.Error.CompanyId !== undefined) {
                  setCompany(result.Error.CompanyId);
                } else {
                  setCompany(12040252);
                }
                setError(error);
                break;
              case 403:
                //@ts-ignore
                setErrorMessage(window.Configs.ERROR_403_CUSTOM);
                setCompany(12040252);
                setError(error);
                break;
              case 500:
                //@ts-ignore
                setErrorMessage(window.Configs.ERROR_500_CUSTOM);
                setCompany(12040252);
                setError(error);
                break;
              default:
                //@ts-ignore
                setErrorMessage(window.Configs.ERROR_GENERIC);
                setCompany(12040252);
                setError(error);
                break;
            }
            setError(error);
            setChecked(false);
            setBlockproccess(true);
            setManuale(false);
            setAvanti(false);
            //@ts-ignore
            setCompany(result.CompanyId);
          }
          setIsLoaded(true);
        },
        (error) => {
          setError(error);
          setStep(1);
          setChecked(false);
          setIsLoaded(true);
          return Promise.reject(error);
        }
      );
  };

  //#region  "API FECTHING"

  useEffect(() => {
    //Estrae l'id da proccessare
    getMyId();
    //Fai il check dell'id
    if (fattibile && myid !== '') {
      setStep(1);
      setIsloading(true);
      const check = async () => {
        await checkurlasync();
      };
      check();
      setIsloading(false);
      //#region COMMENTATO
      // fetch(checkurl + myid)
      //   .then((res) => res.json())
      //   .then(
      //     (result) => {
      //       if (result.RequestStatus === 'OK') {
      //         ///IDCOMPANY
      //         setCompany(result.CompanyId);
      //         //Numero dei pax
      //         if (result.PaxNumber !== undefined) {
      //           setPax(result.PaxNumber);
      //         } else {
      //           setPax(1);
      //         }
      //         setChecked(true);
      //         //Acconsento di andare avanti
      //         setAvanti(true);
      //         //Geolocalizzo
      //         getLocation();
      //         //setStep(2);
      //       } else {
      //         setStep(1);
      //         let rs = result.Error.ErrorCode;
      //         switch (rs) {
      //           case 400:
      //             if (result.Error.ErrorMessage !== null) {
      //               setErrorMessage(result.Error.ErrorMessage);
      //               setCompany(result.Error.CompanyId);
      //             } else {
      //               //@ts-ignore
      //               setErrorMessage(window.Configs.ERROR_400_EMPTY);
      //               setCompany(result.Error.CompanyId);
      //             }
      //             setError(error);
      //             break;
      //           case 401:
      //             //@ts-ignore
      //             setErrorMessage(window.Configs.ERROR_401_CUSTOM);
      //             setCompany(result.Error.CompanyId);
      //             setError(error);
      //             break;
      //           case 403:
      //             //@ts-ignore
      //             setErrorMessage(window.Configs.ERROR_403_CUSTOM);
      //             setCompany(12040252);
      //             setError(error);
      //             break;
      //           case 500:
      //             //@ts-ignore
      //             setErrorMessage(window.Configs.ERROR_500_CUSTOM);
      //             setCompany(12040252);
      //             setError(error);
      //             break;
      //           default:
      //             //@ts-ignore
      //             setErrorMessage(window.Configs.ERROR_GENERIC);
      //             setCompany(12040252);
      //             setError(error);
      //             break;
      //         }
      //         setError(error);
      //         setChecked(false);
      //         setBlockproccess(true);
      //         setManuale(false);
      //         setAvanti(false);
      //         //@ts-ignore
      //         setCompany(result.CompanyId);
      //       }
      //       setIsLoaded(true);
      //     },
      //     (error) => {
      //       setError(error);
      //       setStep(1);
      //       setChecked(false);
      //       setIsLoaded(true);
      //       return Promise.reject(error);
      //     }
      //   );
      //#endregion
    }
  }, [fattibile]);

  //#region  API GET POI

  const getPoi = (latitude: Number, longitude: number) => {
    fetch(getpoiurl + latitude + '/' + longitude)
      .then((res) => res.json())
      .then(
        (result) => {
          if (result.RequestStatus === 'OK') {
            let exit = result.Locator.Exit;
            if (!exit) {
              //console.log('Step: ' + step);
              //console.log('ECCO IL POI: ');
              //console.log(result.Locator.Point);
              //Ottiene con Exit false
              //@ts-ignore
              setReq1({
                PaxNumber: pax,
                Address: {
                  //@ts-ignore
                  Street: address?.street,
                  //@ts-ignore
                  PostalCode: address?.postalCode,
                  City: result.Locator.Point.EndDescription,
                  //@ts-ignore
                  ProvinceCode: address?.provinceCode,
                  //@ts-ignore
                  ProvinceDescr: address?.provinceDescr,
                  //@ts-ignore
                  CountryCode: address?.countryCode,
                  //@ts-ignore
                  FormattedAddress: address?.formattedAddress,
                  //@ts-ignore
                  Latitude: address?.latitude,
                  //@ts-ignore
                  Longitude: address?.longitude,
                },
                Point: {
                  PoiId: result.Locator.Point.PoiId,
                  PoiName: '',
                  Km: result.Locator.Point.Km,
                  TreatCode: '',
                  TreatId: result.Locator.Point.TreatId,
                  HighwayId: result.Locator.Point.HighwayId,
                  HighwayName: result.Locator.Point.HighwayName,
                  HighwayCode: result.Locator.Point.HighwayCode,
                  TreatName: result.Locator.Point.TreatName,
                  Direction: mydirection,
                },
                ExitNote: null,
              });
              setPartenza(result.Locator.Point.StartDescription);
              setArrivo(result.Locator.Point.EndDescription);
              setLocatorExit(false);
              //NON FA DIRECT EXIT
              setStep(3);
            } else {
              //esce con Exit true
              //Salava la nota
              setReq2({
                PaxNumber: pax,
                //@ts-ignore
                ExitNote: note,
                Address: {
                  //@ts-ignore
                  Street: address?.street,
                  //@ts-ignore
                  PostalCode: address?.postalCode,
                  //@ts-ignore
                  City: address?.city,
                  //@ts-ignore
                  ProvinceCode: address?.provinceCode,
                  //@ts-ignore
                  ProvinceDescr: address?.provinceDescr,
                  //@ts-ignore
                  CountryCode: address?.countryCode,
                  //@ts-ignore
                  FormattedAddress: address?.formattedAddress,
                  //@ts-ignore
                  Latitude: address?.latitude,
                  //@ts-ignore
                  Longitude: address?.longitude,
                },
              });

              setShowNotes(true);
              setLocalized(false);
              setManuale(false);
              setUsageGps(false);
              //console.log('Step 2 ecco Locator Exit');
              //console.log(exit);
              setLocatorExit(true);
              //Va direttamente in complete exit
              setDirectExite(true);
            }
          } else {
            //console.log('Check error');
            let rs = result.Error.ErrorCode;
            switch (rs) {
              case 500:
                //@ts-ignore
                setErrorMessage(window.Configs.ERROR_500_CUSTOM);
                setError(error);
                setDirectExite(true);
                break;
              default:
                //console.log(result.Error.ErrorMessage);
                //@ts-ignore
                setErrorMessage(window.Configs.ERROR_GENERIC);
                setError(error);
                setDirectExite(true);
                break;
            }
            setError(error);
            setStep(2);
            setChecked(false);
            setBlockproccess(true);
          }
          setIsLoaded(true);
        },
        (error) => {
          setError(error);
          setStep(1);
          setChecked(false);
          setIsLoaded(true);
          //console.log('SOno in error!!!!!');
          setDirectExite(true);
          return Promise.reject(error);
        }
      );
  };

  useEffect(() => {
    if (directExit) {
      setIsloading(true);
      postCompleteExit(myid);
      setIsloading(false);
    }
  }, [directExit]);

  //#endregion

  //#region  POSTCOMPLETE & POSTCOMPLETEEXIT
  const postComplete = async (idguid: string) => {
    req1.Point.Direction = mydirection;
    req1.PaxNumber = pax;
    //@ts-ignore
    req1.Address.Street = address?.street;
    //@ts-ignore
    req1.Address.City = address?.city;
    //@ts-ignore
    req1.Address.ProvinceCode = address?.provinceCode;
    //@ts-ignore
    req1.Address.PostalCode = address?.postalCode;
    //@ts-ignore
    req1.Address.ProvinceDescr = address?.provinceDescr;
    //@ts-ignore
    req1.Address.CountryCode = address?.countryCode;
    //@ts-ignore
    req1.Address.FormattedAddress = address?.formattedAddress;
    //@ts-ignore
    req1.Address.Latitude = address?.latitude;
    //@ts-ignore
    req1.Address.Longitude = address?.longitude;
    const requestOptions = {
      method: 'POST',
      headers: { 'Content-Type': 'application/json' },
      body: JSON.stringify(req1),
    };
    await fetch(postcompleteurl + idguid, requestOptions)
      .then((response) => response.json())
      .then(
        (data) => {
          setStep(5);
          setDirectionClicked(true);
        },
        (error) => {
          setStep(6);
          setDirectionClicked(true);
        }
      );
  };

  const postCompleteExit = async (idguid: string) => {
    //console.log('confermo!!!');
    req2.ExitNote = note;
    req2.PaxNumber = pax;
    //@ts-ignore
    req2.Address.Street = address?.street;
    //@ts-ignore
    req2.Address.City = address?.city;
    //@ts-ignore
    req2.Address.ProvinceCode = address?.provinceCode;
    //@ts-ignore
    req2.Address.PostalCode = address?.postalCode;
    //@ts-ignore
    req2.Address.ProvinceDescr = address?.provinceDescr;
    //@ts-ignore
    req2.Address.CountryCode = address?.countryCode;
    //@ts-ignore
    req2.Address.FormattedAddress = address?.formattedAddress;
    //@ts-ignore
    req2.Address.Latitude = address?.latitude;
    //@ts-ignore
    req2.Address.Longitude = address?.longitude;

    const requestOptions = {
      method: 'POST',
      headers: { 'Content-Type': 'application/json' },
      body: JSON.stringify(req2),
    };
    //setDirectionClicked(false);
    await fetch(postcompleteurl + idguid, requestOptions)
      .then((response) => response.json())
      .then(
        (data) => {
          setDirectionClicked(true);
          setStep(4);
        },
        (error) => {
          setStep(4);
          setDirectionClicked(true);
        }
      );
  };

  //#endregion

  //#region COMMANDI TASTI
  //Gestione click per il numero di passeggeri
  const handlePress = (operation: string) => {
    if (operation === '+' && pax < 7) {
      setPax(pax + 1);
    } else if (operation === '-' && pax > 1) {
      setPax(pax - 1);
    }
  };

  useEffect(() => {
    //console.log(enabled);
  }, [enabled]);

  //Gestione del numero pax
  const handleChange = (e: React.ChangeEvent<HTMLInputElement>) => {
    setPax(parseInt(e.target.value));
  };

  const handletextareachange = (e: React.ChangeEvent<HTMLTextAreaElement>) => {
    setNote(e.target.value);
    //console.log(note);
  };

  //
  const handleDirectionPress = (operation: string) => {
    if (operation === 'partenza') {
      setDirection(1);
    } else if (operation === 'arrivo') {
      setDirection(0);
    }
    setAttivaBtnDRCT(false);
    setAttivaBtnNSQ(false);
    setDirectionClicked(true);
  };

  useEffect(() => {
    //console.log('My direction:');
    //console.log(mydirection);
    if (mydirection !== -1) {
      postComplete(myid);
    }
  }, [mydirection, directionclicked]);

  useEffect(() => {
    //console.log('My direction:');
    //console.log(mydirection);
  }, [mydirection, directionclicked]);

  const onPresInditro = () => {
    setBack(true);
    setStep(2);
  };

  useEffect(() => {
    if (step == 1) {
      //getLocation();
    }
    if (step == 2) {
      //getLocation();
    }
    //log(step);
  }, [back, localized]);

  //GESTIONE DEL CONTROLLO AVANTI
  const onPresAvanti = () => {
    switch (step) {
      case 0:
        setStep(1);
        break;
      case 1:
        setStep(2);
        break;
      case 2:
        // @ts-ignore
        getPoi(address?.latitude, address?.longitude);
        break;
      case 3:
        //Locator Exit è stato false
        //Raccolgo i dati per completare
        setDirectionClicked(false);
        postComplete(myid);
        break;

      case 4:
        //Locator Exit è stato True
        //Mando la nota e vado inc complete
        //console.log('btn click step 4');
        postCompleteExit(myid);

        break;
      case 5:
        window.alert('Step ' + step);
        break;
      case 6:
        window.alert('Step ' + step);
        break;
      default:
        if (blockproccess) {
          setStep(1);
        }
        break;
    }
  };

  const handleClickContinua = (
    event: MouseEvent<HTMLButtonElement | HTMLAnchorElement>
  ) => {
    //event.preventDefault();
    //alert(event.currentTarget.tagName);
    switch (step) {
      case 0:
        setStep(1);
        break;
      case 1:
        setStep(2);
        break;
      case 2:
        // @ts-ignore
        getPoi(address?.latitude, address?.longitude);
        break;
      case 3:
        //Locator Exit è stato false
        //Raccolgo i dati per completare
        setDirectionClicked(false);
        postComplete(myid);
        break;

      case 4:
        //Locator Exit è stato True
        //Mando la nota e vado inc complete
        //console.log('btn click step 4');
        setDirectionClicked(false);
        postCompleteExit(myid);
        seForzanogeo(true);
        break;
      case 5:
        window.alert('Step ' + step);
        break;
      case 6:
        window.alert('Step ' + step);
        break;
      default:
        if (blockproccess) {
          setStep(1);
        }
        break;
    }
  };
  useEffect(() => {
    //console.log(713);
    // if (forzanogeo === true) {
    //   postCompleteExit(myid);
    // }
  }, [forzanogeo]);

  const onPresNotHere = (beenhere: boolean) => {
    setAttivaBtnNSQ(false);
    setShowNotes(true);
    setLocalized(false);
    setDirectExite(true);
    //setStep(4);
  };

  //showNotes
  useEffect(() => {
    //console.log(724);
    //console.log(step);
    //postCompleteExit(myid);
  }, [showNotes]);

  const handlePressBack = (e: MouseEvent) => {
    e.preventDefault();
    if (step > 1) {
      switch (step) {
        case 3:
          setStep(2);
          break;
        case 4:
          setStep(2);
          break;
        case 5:
          break;
        case 6:
          break;
        default:
          setStep(step - 1);
          break;
      }
    }
  };

  //@ts-ignore
  const onSuccess = (position) => {
    let mypos =
      'Latitude: ' +
      position.coords.latitude +
      '\n' +
      'Longitude: ' +
      position.coords.longitude +
      '\n' +
      'Altitude: ' +
      position.coords.altitude +
      '\n' +
      'Accuracy: ' +
      position.coords.accuracy +
      '\n' +
      'Altitude Accuracy: ' +
      position.coords.altitudeAccuracy +
      '\n' +
      'Heading: ' +
      position.coords.heading +
      '\n' +
      'Speed: ' +
      position.coords.speed +
      '\n' +
      'Timestamp: ' +
      position.timestamp +
      '\n';
    //console.log(mypos);
    //setStep(1);
  };

  //@ts-ignore
  const onError = (error) => {
    //alert('code: ' + error.code + '\n' + 'message: ' + error.message + '\n');
    //@ts-ignore
    window.alert(
      //@ts-ignore
      window.Configs.ERROR_MESSAGE_ACTIVE_GPS
    );
  };

  //#endregion
  if (isloading) {
    return (
      <div>
        {' '}
        <div className='center'>
          <br />
          <br />
          <br />
          <br />
          <br />
          <br />
          <br />
          <br />
          <p>Caricamento in corso...</p>
          <br />
          <EuiLoadingSpinner size='xl' />
        </div>
      </div>
    );
  }

  if (blockproccess) {
    return (
      <div>
        {/* <TopBar mystep={step} onPressBack={handlePressBack} /> */}
        <EuiSpacer size='xl' />
        <div className='containerstart'>
          <div className='column is-four-fifths is-narrow has-text-centered'>
            <figure className='image is-max-width-200 is-inline-block'>
              {!isloading && company !== 0 && company !== undefined ? (
                <img className='image-logo-start' src={GetLogo(company)} />
              ) : (
                <p>
                  <EuiLoadingSpinner size='xl' />
                </p>
              )}
            </figure>
            <h2>Assistenza digitale</h2>
          </div>
          <div className='column is-four-fifths is-narrow has-text-centered'>
            <h1 className='subtitle'>Attenzione!</h1>
            <p className='mytext'>{errormesage}</p>
          </div>
        </div>
      </div>
    );
  } else {
    switch (step) {
      case 0:
        return (
          <div>
            {' '}
            {/* <TopBar mystep={step} onPressBack={handlePressBack} /> */}
            <EuiSpacer size='xl' />
            <div className='containerstart'>
              <div className='column is-four-fifths is-narrow has-text-centered'>
                <figure className='image is-max-width-200 is-inline-block'>
                  {!isloading && company !== 0 && company !== undefined ? (
                    <img className='image-logo-start' src={GetLogo(company)} />
                  ) : (
                    <p>
                      <EuiLoadingSpinner size='xl' />
                    </p>
                  )}
                  {/* <img className='image-logo-start' src={GetLogo(company)} /> */}
                </figure>
                <h2>Assistenza digitale</h2>
              </div>
              <div className='column is-four-fifths is-narrow has-text-centered'>
                <h2 className='subtitle'>Attenzione!</h2>
                <p className='mytext'>
                  {
                    //@ts-ignore
                    window.Configs.ERROR_MESSAGE_ACTIVE_GPS
                  }
                  <br />
                  <br />
                  <br />
                </p>
              </div>
            </div>
            <div className='center'>
              <div className='firstobottom'>
                <div>
                  <button
                    className='myButton'
                    onClick={() => {
                      navigator.geolocation.getCurrentPosition(
                        onSuccess,
                        onError
                      );
                    }}
                  >
                    UTILIZZA GPS
                  </button>

                  {'  '}
                  <button
                    className='myButton'
                    disabled={!attivaBtnNSQ}
                    onClick={() => {
                      onPresNotHere(true);
                    }}
                  >
                    RICHIAMATEMI
                  </button>
                  {'  '}
                </div>
              </div>
            </div>
          </div>
        );
      case 1:
        return (
          <div>
            {' '}
            {/* <TopBar mystep={step} onPressBack={handlePressBack} /> */}
            <EuiSpacer size='xl' />
            <div className='containerstart'>
              <div className='column is-four-fifths is-narrow has-text-centered'>
                <figure className='image is-max-width-200 is-inline-block'>
                  {!isloading && company !== 0 && company !== undefined ? (
                    <img className='image-logo-start' src={GetLogo(company)} />
                  ) : (
                    <p>
                      <EuiLoadingSpinner size='xl' />
                    </p>
                  )}
                  {/* <img className='image-logo-start' src={GetLogo(company)} /> */}
                </figure>
                <h2>Assistenza digitale</h2>
              </div>

              <div className='column is-four-fifths is-narrow has-text-centered'>
                <h1 className='subtitle'>Benvenuto!</h1>
                <p className='mytext'>
                  “Ti aiuteremo a risolvere velocemente il tuo problema, aiutaci
                  a localizzarti con pochi click!”
                  <br />
                  <br />
                  <label>
                    <input
                      type='checkbox'
                      onChange={(e) => setEnabled(e.target.checked)}
                    />{' '}
                    I agree to the terms of conditions
                  </label>
                  <br />
                  <br />
                  <span>
                    <a
                      className='hyperlink'
                      href={printhyperlink(company)}
                      target='_blank'
                    >
                      Terms of conditions
                    </a>
                  </span>
                </p>
              </div>

              <div
                className='column is-four-fifths is-narrow has-text-centered is-size-1'
                id='langFlags'
              >
                <span className='e1a-flag_gb'></span>
              </div>

              <div className='column is-four-fifths is-narrow has-text-centered'>
                <label className='checkbox' id='termsOfUse'></label>
              </div>
            </div>
            <Footerbar
              onPresAvanti={handleClickContinua}
              enabled={enabled}
              step={step}
            />
          </div>
        );
      case 2:
        return (
          <div className='relook'>
            {' '}
            {/* <TopBar mystep={step} onPressBack={handlePressBack} /> */}
            {/* <div className='topnav'>
              <div className='divbtnback'></div>
              <div className='center'>
                <b>LA MIA POSIZIONE</b>
              </div>
            </div>
            <div className='divider-map'></div> */}
            <div>
              <div className='topnav'>
                <div className='divbtnback'></div>
                <div className='center'>
                  <b>LA MIA POSIZIONE</b>
                </div>
              </div>
              <div className='divider-map'></div>
              <GoogleMapFull address={address} setAddress={setAddress} />
              <div className='divider-map'></div>
              <div className='firstobottom'>
                <div className='mytext'>In quanti siete a bordo del mezzo?</div>
                <br />
                <div>
                  <button
                    className='myButton'
                    onClick={() => {
                      handlePress('-');
                    }}
                  >
                    -
                  </button>
                  {'  '}
                  <input
                    className='css-input-num'
                    type='number'
                    readOnly
                    value={pax}
                    onChange={handleChange}
                  />
                  {'  '}
                  <button
                    className='myButton'
                    onClick={() => {
                      handlePress('+');
                    }}
                  >
                    +
                  </button>
                  {'  '}
                </div>
                {/* <div className='divider-map'></div>
                <div className='center'>
                  <button
                    className='myButton2'
                    disabled={enabled}
                    onClick={() => {
                      onPresAvanti();
                    }}
                  >
                    Continua
                  </button>
                </div> */}
              </div>
            </div>
            <div className='divider-map'></div>
            <Footerbar
              onPresAvanti={handleClickContinua}
              enabled={enabled}
              step={step}
            />
          </div>
        );
      case 3:
        return (
          <div>
            {' '}
            {/* <TopBar mystep={step} onPressBack={handlePressBack} /> */}
            <div className='topnav'>
              <div className='divbtnback'>
                <button onClick={handlePressBack}>
                  <b>{'     <<<    '}</b>
                </button>
              </div>
              <div className='center'>
                <b>LA MIA DIREZIONE</b>
              </div>
            </div>
            <div className='divider-map'></div>{' '}
            <div className='center'>
              <div className='column is-four-fifths is-narrow has-text-centered'>
                <figure className='image is-max-width-200 is-inline-block'>
                  {!isloading ? (
                    <img className='image-logo-start' src={GetLogo(company)} />
                  ) : (
                    <p>
                      <EuiLoadingSpinner size='xl' />
                    </p>
                  )}
                  {/* <img className='image-logo-start' src={GetLogo(company)} /> */}
                </figure>
                <h2>Assistenza digitale</h2>
              </div>
              <br />
              <br />
              <br />
              <br />
              <br />
              <div className='mytext'>
                Abbiamo rilevato che ti trovi sull'autostrada
                <br />
                {/* <b>{address?.street}</b>. */}
                <b>
                  {req1?.Point.HighwayCode} - {req1?.Point.HighwayName}
                </b>
                .
                <br />
                In che direzione stai andando?{' '}
              </div>
            </div>
            <div>
              <div className='footernav'>
                <div className='center'>
                  <button
                    className='myButton'
                    disabled={!attivaBtnDRCT}
                    onClick={() => {
                      handleDirectionPress('partenza');
                    }}
                  >
                    {partenza}
                  </button>
                  {'  '}
                  <button
                    className='myButton'
                    disabled={!attivaBtnDRCT}
                    onClick={() => {
                      handleDirectionPress('arrivo');
                    }}
                  >
                    {' '}
                    {arrivo}
                  </button>
                </div>
                <div className='center'>
                  {'  '}
                  <button
                    className='myButton'
                    disabled={!attivaBtnNSQ}
                    onClick={() => {
                      onPresNotHere(true);
                    }}
                  >
                    Non sono qui
                  </button>
                </div>
              </div>
            </div>
            <EuiSpacer size='xl' />
          </div>
        );
      case 4:
        return (
          <div>
            {' '}
            <div className='divider-map'></div>{' '}
            <div className='center'>
              <div className='column is-four-fifths is-narrow has-text-centered'>
                <figure className='image is-max-width-200 is-inline-block'>
                  {!isloading && company !== 0 && company !== undefined ? (
                    <img className='image-logo-start' src={GetLogo(company)} />
                  ) : (
                    <p>
                      <EuiLoadingSpinner size='xl' />
                    </p>
                  )}
                  {/* <img className='image-logo-start' src={GetLogo(company)} /> */}
                </figure>
                <h2>Assistenza digitale</h2>
              </div>
              <br /> <br />
              <div className='mytext'>
                la tua richiesta di assistenza è stata registrata e sarà gestita
                con la massima priorità <br /> verrai ricontattato a breve da un
                nostro operatore per completare la richiesta <br /> ti chiediamo
                la cortesia in questo lasso di tempo di tenere il cellulare
                libero.
                <br />
                FINE.
              </div>
            </div>
          </div>
        );
      case 5:
        return (
          <div>
            {' '}
            <EuiSpacer size='xl' />
            <div className='containerstart'>
              <div className='column is-four-fifths is-narrow has-text-centered'>
                <figure className='image is-max-width-200 is-inline-block'>
                  {!isloading && company !== 0 && company !== undefined ? (
                    <img className='image-logo-start' src={GetLogo(company)} />
                  ) : (
                    <p>
                      <EuiLoadingSpinner size='xl' />
                    </p>
                  )}
                  {/* <img className='image-logo-start' src={GetLogo(company)} /> */}
                </figure>
                <h2>Assistenza digitale</h2>
              </div>

              <div className='column is-four-fifths is-narrow has-text-centered'>
                <h1 className='subtitle'>Fine!</h1>
                <p>
                  la tua richiesta di assistenza è stata registrata e sarà
                  gestita con la massima priorità.
                  <br /> il soccorso arriverà sul posto entro 30 minuti
                  <br /> ti chiediamo la cortesia in questo lasso di tempo di
                  tenere il cellulare libero per eventuali richieste di
                  informazioni che potrebbero essere fatte dalla centrale
                  operativa del soccorso
                  <br />
                  FINE.
                </p>
              </div>

              <div
                className='column is-four-fifths is-narrow has-text-centered is-size-1'
                id='langFlags'
              >
                <span className='e1a-flag_gb'></span>
              </div>

              <div className='column is-four-fifths is-narrow has-text-centered'>
                <label className='checkbox' id='termsOfUse'></label>
              </div>
            </div>
          </div>
        );
      case 6:
        return (
          <div>
            {' '}
            <EuiSpacer size='xl' />
            <div className='containerstart'>
              <div className='column is-four-fifths is-narrow has-text-centered'>
                <figure className='image is-max-width-200 is-inline-block'>
                  {!isloading && company !== 0 && company !== undefined ? (
                    <img className='image-logo-start' src={GetLogo(company)} />
                  ) : (
                    <p>
                      <EuiLoadingSpinner size='xl' />
                    </p>
                  )}
                  {/* <img className='image-logo-start' src={GetLogo(company)} /> */}
                </figure>
                <h2>Assistenza digitale</h2>
              </div>

              <div className='column is-four-fifths is-narrow has-text-centered'>
                <h1 className='subtitle'>Fine!</h1>
                <p>
                  la tua richiesta di assistenza è stata registrata e sarà
                  gestita con la massima priorità <br /> verrai ricontattato a
                  breve da un nostro operatore per completare la richiesta{' '}
                  <br /> ti chiediamo la cortesia in questo lasso di tempo di
                  tenere il cellulare libero
                  <br />
                  FINE.
                </p>
              </div>

              <div
                className='column is-four-fifths is-narrow has-text-centered is-size-1'
                id='langFlags'
              >
                <span className='e1a-flag_gb'></span>
              </div>

              <div className='column is-four-fifths is-narrow has-text-centered'>
                <label className='checkbox' id='termsOfUse'></label>
              </div>
            </div>
          </div>
        );

      default:
        return (
          <div>
            {' '}
            <TopBar mystep={step} onPressBack={handlePressBack} />
            <EuiSpacer size='s' />
          </div>
        );
    }
  }
};
